import { safeArray, shortText, formatShortText } from "../utils/text";
import { PlaceholderImage } from "../utils/imageHolder";
import "./../ImageAnalysisCardsNew.css";
import { reportsApi } from "../../../../API/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLanguage, faTag, faMagnifyingGlassPlus, faDownload, faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

// Card Component
// Card Component


export function Card({ item, onOpen, index }) {
  const _id = item?._id || "unknown";
  const image_url = item?.image_url || null;
  const category = item?.category || {};
  const lang = item?.lang || {};
  const caption = item?.caption || {};
  const status = item?.status || "unknown";

  const categories = safeArray(category?.categories);
  const languages = safeArray(lang?.detected_languages).filter(Boolean);
  const excerpt = shortText(
    caption?.description || lang?.extracted_text || "No description",
    120
  );
  const explanations = safeArray(category?.explanations);
  const explanationText = explanations.length > 0 ? explanations[0] : "";

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "completed":
      case "success":
        return { bg: "#dcfce7", text: "#15803d", dot: "#16a34a" };
      case "processing":
      case "pending":
        return { bg: "#fef3c7", text: "#92400e", dot: "#f59e0b" };
      case "failed":
      case "error":
        return { bg: "#fee2e2", text: "#991b1b", dot: "#dc2626" };
      default:
        return { bg: "#e0e7ff", text: "#3730a3", dot: "#6366f1" };
    }
  };

  const statusColors = getStatusColor(status);

  const handleDownload = async (e, imageId) => {
    e.stopPropagation();
    if (!imageId) return;

    try {

      const response = await reportsApi.post(
        `/image-analysis`,
        { imageId },
        { responseType: "blob" }
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `CSMART_Image_Analysis_Report-${imageId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
    }
  };



  return (
    <div
      onClick={() => onOpen(_id)}
      className="analysis-card"
      style={{
        animationDelay: `${index * 0.05}s`,
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onOpen(_id)}
    >
      {/* Image Section */}
      <div className="card-image-wrapper">
        {image_url ? (
          <img
            src={image_url}
            alt={`analysis-${_id}`}
            className="card-image"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.style.display = "none";
              e.currentTarget.parentElement.innerHTML =
                '<div class="card-placeholder-text">Image unavailable</div>';
            }}
          />
        ) : (
          <div className="card-placeholder-text">No image</div>
        )}
      </div>

      {/* Content Section */}
      <div className="card-content-wrapper">
        {/* Status Badge */}
        <div
          className="card-status"
          style={{
            backgroundColor: statusColors.bg,
            color: statusColors.text,
          }}
        >
          <span
            className="status-dot"
            style={{ backgroundColor: statusColors.dot }}
          ></span>
          {status}
        </div>

        {/* Explanation - New Section */}
        {explanationText && (
          <p className="card-explanation">{explanationText}</p>
        )}

        {/* Description
        <p className="card-description">{formatShortText(excerpt)}</p> */}

        {/* Tags Section */}
        <div className="card-tags">
          {/* Languages */}
          {languages.slice(0, 2).map((lang, idx) => (
            <span key={`lang-${idx}`} className="tag tag-language">
              <FontAwesomeIcon icon={faLanguage} />
              {lang}
            </span>
          ))}

          {/* Categories */}
          {categories.slice(0, 2).map((cat, idx) => (
            <span key={`cat-${idx}`} className="tag tag-category">
              <FontAwesomeIcon icon={faTag} />
              {shortText(cat, 15)}
            </span>
          ))}
        </div>

        {/* Footer */}

        {/* Footer */}
        <div className="card-footer">
          <span className="card-footer-text">
            <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
            View details
          </span>
          <div className="card-footer-actions">

            <button
              className="card-download-btn"
              onClick={(e) => handleDownload(e, _id)}
              title="Download image"
              aria-label="Download image"
            >
              <FontAwesomeIcon icon={faDownload} />
            </button>

            <FontAwesomeIcon icon={faArrowRight} className="card-footer-arrow" />
          </div>
        </div>



      </div>
    </div>
  );
}
